import { defaultFlux } from '../../../utils/fluxes';
import { PARTNER_CONFIG_LOAD_FAIL } from '../../service/store/service.action-types';
import * as actions from './wizard.action-types';

const INITIAL_STATE = {
  product: undefined,
  completedStep: 0,
  currentStep: 1,
  totalSteps: undefined,
  directionForward: true,
  steps: [],
  riskType: 'auto',
  fluxes: [],
  activeFlux: null,
  isSheet: false,
  editedData: false,
  hasChangeFlux: false,
};

const wizardReducer = (state = INITIAL_STATE, action) => {
  let historyV2;
  switch (action.type) {
    case actions.GET_STEPS:
      return {
        ...state,
      };
    case actions.GET_STEPS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case actions.GET_STEPS_FAIL:
      return {
        ...state,
      };
    case actions.NEXT_STEP:
      const { fromStepV2, ...payload } = action.payload;
      historyV2 = state.historyV2 || [];

      if (fromStepV2) {
        historyV2.push(fromStepV2);
      }
      return {
        ...state,
        ...payload,
        ...(historyV2.length && { historyV2 }),
        directionForward: true,
        hasChangeFlux: false,
      };
    case actions.RESET_PROGRESS:
      historyV2 = state.wizard?.historyV2;

      if (historyV2) {
        const newStepIdx = action.payload.currentStep;
        const newCurrentStepV2 = historyV2[newStepIdx];
        return {
          ...state,
          ...action.payload,
          currentStepV2: newCurrentStepV2,
          directionForward: false,
          hasChangeFlux: false,
          entryFlux: defaultFlux,
        };
      }

      return {
        ...state,
        ...action.payload,
        directionForward: false,
        hasChangeFlux: false,
        entryFlux: defaultFlux,
      };
    case actions.SET_RISK_TYPE:
      return {
        ...state,
        riskType: action.payload,
      };
    case actions.EDITED_DATA:
      return {
        ...state,
        editedData: action.payload.value,
      };
    case actions.CHANGE_FLUX:
      return {
        ...state,
        ...action.payload,
        directionForward: false,
        hasChangeFlux: true,
      };
    case PARTNER_CONFIG_LOAD_FAIL:
      return {
        ...state,
        ...action.payload,
        entryFlux: defaultFlux,
        activeFlux: defaultFlux,
      };
    case actions.SAVE_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case actions.RESET_STATE:
      return {
        product: undefined,
        completedStep: 0,
        currentStep: 1,
        totalSteps: undefined,
        directionForward: true,
        steps: [],
        riskType: 'auto',
        fluxes: [],
        activeFlux: null,
        hasChangeFlux: false,
      };
    default:
      return state;
  }
};

export default wizardReducer;
